import { Module } from 'vuex';
import { RECORD_EXPORT } from '@/store/action_types';
import ActivityLog, { RecordExport } from '@/services/activity_log';

const activityLog: Module<any, {}> = {
  actions: {
    [RECORD_EXPORT]: async ({ rootGetters }: any, payload: RecordExport) => {
      const sessionToken = rootGetters.sessionToken;
      if (!sessionToken) return;
      await ActivityLog.recordExport(payload, sessionToken);
    },
  },
};

export default activityLog;
